import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';

// const shouldIgnoreRelatedAppsError = (message) =>
//   typeof message === 'string' &&
//   message.includes('getInstalledRelatedApps') &&
//   message.includes('top-level browsing contexts');

// window.addEventListener('unhandledrejection', (event) => {
//   const reason = event?.reason;
//   const message = typeof reason === 'string' ? reason : reason?.message;

//   if (shouldIgnoreRelatedAppsError(message)) {
//     event.preventDefault();
//   }
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

